import styles from './template.css';
import template from './template';
import {AoflElement, customElement} from '@aofl/element';
import {
  colorMap,
} from '@modules/constants-enumerate';
import {dashboardLabels} from '@modules/i18n-labels';
import {property} from 'lit-element';

/**
 * @summary NodeStatusLegend
 * @extends {AoflElement}
 */
@customElement('node-status-legend')
class NodeStatusLegend extends AoflElement {
  /**
   * Creates an instance of LegendElement.
   */
  constructor() {
    super();
  }

  @property({type: Array})
  legend = [
    {
      color: colorMap.prior_knowledge,
      label: dashboardLabels.PRIOR_KNOWLEDGE,
    },
    {
      color: colorMap.mastery_achieved,
      label: dashboardLabels.COMPLETED,
    },
    {
      color: colorMap.in_progress,
      label: dashboardLabels.IN_PROGRESS,
    },
    {
      color: colorMap.struggling,
      label: dashboardLabels.STRUGGLING,
    },
  ];

  /**
   * @readonly
   */
  static is = 'node-status-legend';

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default NodeStatusLegend;
